import { useState, useCallback, useEffect, useRef } from "react";
import { TechAvailabilityResponse } from "../../../Interface/scheduler/form";

export const useTechAvailabilityManager = (
  initialScheduleCollection: TechAvailabilityResponse[],
) => {
  const [techAvailability, setTechAvailability] = useState<
    TechAvailabilityResponse[]
  >(initialScheduleCollection);
  const isFirstRender = useRef(true);

  // Only sync with parent on first mount, OR if parent has new data and we were empty
  // Do NOT unconditionally reset whenever parent changes (prevents losing fetched data)
  useEffect(() => {
    if (isFirstRender.current) {
      // First render - take parent data
      setTechAvailability(initialScheduleCollection);
      isFirstRender.current = false;
    } else if (
      initialScheduleCollection.length > 0 &&
      techAvailability.length === 0
    ) {
      // Parent got new data while we're empty - take it
      // (happens when user navigates back and parent refetches)
      setTechAvailability(initialScheduleCollection);
    }
    // Otherwise: keep our data (preserves fetched dates when parent hasn't updated yet)
  }, [initialScheduleCollection, techAvailability.length]);

  const handleUpdateTechAvailability = useCallback(
    (newAvailability: TechAvailabilityResponse[]) => {
      setTechAvailability(newAvailability);
    },
    [],
  );

  const appendTechAvailability = useCallback(
    (additionalAvailability: TechAvailabilityResponse[]) => {
      setTechAvailability((prev) => [...prev, ...additionalAvailability]);
    },
    [],
  );

  return {
    techAvailability,
    handleUpdateTechAvailability,
    appendTechAvailability,
  };
};
